import {AES} from "crypto-js";
import {enc} from "crypto-js";

class GlobalVar{
    constructor() {
      this.studentListMustRefetch = false;
      this.accountfunctions = null;

      this.mailSubject = "";
      this.mailText = "";
      this.studyListObject = {
        '00': 'Generic programmes and qualifications',
        '001': 'Basic programmes and qualifications'
      }
      // studyList - deprecated. There is a table in the database with all updated codes from now one.
      this.studyList = [{code:'00',text:'Generic programmes and qualifications'},{code:'001',text:'Basic programmes and qualifications'},{code:'0011',text:'Basic programmes and qualifications'},{code:'002',text:'Literacy and numeracy'},{code:'0021',text:'Literacy and numeracy'},{code:'003',text:'Personal skills and development'},{code:'0031',text:'Personal skills and development'},{code:'01',text:'Education'},{code:'011',text:'Education'},{code:'0111',text:'Education science'},{code:'0112',text:'Training for pre-school teachers'},{code:'0113',text:'Teacher training without subject specialisation'},{code:'0114',text:'Teacher training with subject specialisation'},{code:'018',text:'Interdisciplinary programmes involving broad field 01'},{code:'0188',text:'Interdisciplinary programmes involving broad field 01'},{code:'02',text:'Arts and humanities'},{code:'021',text:'Arts'},{code:'0211',text:'Audio-visual techniques and media production'},{code:'0212',text:'Fashion, interior and industrial design'},{code:'0213',text:'Fine arts'},{code:'0214',text:'Handicrafts'},{code:'0215',text:'Music and performing arts'},{code:'022',text:'Humanities (except languages)'},{code:'0221',text:'Religion and theology'},{code:'0222',text:'History and archaeology'},{code:'0223',text:'Philosophy and ethics'},{code:'023',text:'Languages'},{code:'0231',text:'Language acquisition'},{code:'0232',text:'Literature and linguistics'},{code:'028',text:'Interdisciplinary programmes involving broad field 02'},{code:'0288',text:'Interdisciplinary programmes involving broad field 02'},{code:'03',text:'Social sciences, journalism and information'},{code:'031',text:'Social and behavioural sciences'},{code:'0311',text:'Economics'},{code:'0312',text:'Political sciences and civics'},{code:'0313',text:'Psychology'},{code:'0314',text:'Sociology and cultural studies'},{code:'032',text:'Journalism and information'},{code:'0321',text:'Journalism and reporting'},{code:'0322',text:'Library, information and archival studies'},{code:'038',text:'Interdisciplinary programmes involving broad field 03'},{code:'0388',text:'Interdisciplinary programmes involving broad field 03'},{code:'04',text:'Business, administration and law'},{code:'041',text:'Business and administration'},{code:'0411',text:'Accounting and taxation'},{code:'0412',text:'Finance, banking and insurance'},{code:'0413',text:'Management and administration'},{code:'0414',text:'Marketing and advertising'},{code:'0415',text:'Secretarial and office work'},{code:'0416',text:'Wholesale and retail sales'},{code:'0417',text:'Work skills'},{code:'042',text:'Law'},{code:'0421',text:'Law'},{code:'048',text:'Interdisciplinary programmes involving broad field 04'},{code:'0488',text:'Interdisciplinary programmes involving broad field 04'},{code:'05',text:'Natural sciences, mathematics and statistics'},{code:'051',text:'Biological and related sciences'},{code:'0511',text:'Biology'},{code:'0512',text:'Biochemistry'},{code:'052',text:'Environment'},{code:'0521',text:'Environmental sciences'},{code:'0522',text:'Natural environments and wildlife'},{code:'053',text:'Physical sciences'},{code:'0531',text:'Chemistry'},{code:'0532',text:'Earth sciences'},{code:'0533',text:'Physics'},{code:'054',text:'Mathematics and statistics'},{code:'0541',text:'Mathematics'},{code:'0542',text:'Statistics'},{code:'058',text:'Interdisciplinary programmes involving broad field 05'},{code:'0588',text:'Interdisciplinary programmes involving broad field 05'},{code:'06',text:'Information and Communication Technologies'},{code:'061',text:'Information and Communication Technologies'},{code:'0611',text:'Computer use'},{code:'0612',text:'Database and network design and administration'},{code:'0613',text:'Software and applications development and analysis'},{code:'068',text:'Interdisciplinary programmes involving broad field 06'},{code:'0688',text:'Interdisciplinary programmes involving broad field 06'},{code:'07',text:'Engineering, manufacturing and construction'},{code:'071',text:'Engineering and engineering trades'},{code:'0711',text:'Chemical engineering and processes'},{code:'0712',text:'Environmental protection technology'},{code:'0713',text:'Electricity and energy'},{code:'0714',text:'Electronics and automation'},{code:'0715',text:'Mechanics and metal trades'},{code:'0716',text:'Motor vehicles, ships and aircraft'},{code:'072',text:'Manufacturing and processing'},{code:'0721',text:'Food processing'},{code:'0722',text:'Materials (glass, paper, plastic and wood)'},{code:'0723',text:'Textiles (clothes, footwear and leather)'},{code:'0724',text:'Mining and extraction'},{code:'073',text:'Architecture and construction'},{code:'0731',text:'Architecture and town planning'},{code:'0732',text:'Building and civil engineering'},{code:'078',text:'Interdisciplinary programmes involving broad field 07'},{code:'0788',text:'Interdisciplinary programmes involving broad field 07'},{code:'08',text:'Agriculture, forestry, fisheries and veterinary'},{code:'081',text:'Agriculture'},{code:'0811',text:'Crop and livestock production'},{code:'0812',text:'Horticulture'},{code:'082',text:'Forestry'},{code:'0821',text:'Forestry'},{code:'083',text:'Fisheries'},{code:'0831',text:'Fisheries'},{code:'084',text:'Veterinary'},{code:'0841',text:'Veterinary'},{code:'088',text:'Interdisciplinary programmes involving broad field 08'},{code:'0888',text:'Interdisciplinary programmes involving broad field 08'},{code:'09',text:'Health and welfare'},{code:'091',text:'Health'},{code:'0911',text:'Dental studies'},{code:'0912',text:'Medicine'},{code:'0913',text:'Nursing and midwifery'},{code:'0914',text:'Medical diagnostic and treatment technology'},{code:'0915',text:'Therapy and rehabilitation'},{code:'0916',text:'Pharmacy'},{code:'0917',text:'Traditional and complementary medicine and therapy'},{code:'092',text:'Welfare'},{code:'0921',text:'Care of the elderly and of disabled adults'},{code:'0922',text:'Child care and youth services'},{code:'0923',text:'Social work and counselling'},{code:'098',text:'Interdisciplinary programmes involving broad field 09'},{code:'0988',text:'Interdisciplinary programmes involving broad field 09'},{code:'10',text:'Services'},{code:'101',text:'Personal services'},{code:'1011',text:'Domestic services'},{code:'1012',text:'Hair and beauty services'},{code:'1013',text:'Hotel, restaurants and catering'},{code:'1014',text:'Sports'},{code:'1015',text:'Travel, tourism and leisure'},{code:'102',text:'Hygiene and occupational health services'},{code:'1021',text:'Community sanitation'},{code:'1022',text:'Occupational health and safety'},{code:'103',text:'Security services'},{code:'1031',text:'Military and defence'},{code:'1032',text:'Protection of persons and property'},{code:'104',text:'Transport services'},{code:'1041',text:'Transport services'},{code:'108',text:'Interdisciplinary programmes involving broad field 10'},{code:'1088',text:'Interdisciplinary programmes involving broad field 10'}];

      this.OlaReasons = {
        1: "Previously selected educational component is not available at the Receiving Institution",
        2: "Component is in a different language than previously specified in the course catalogue",
        3: "Timetable conflict",
        4: "Other (please specify)",
        5: "Substituting a deleted component",
        6: "Extending the mobility period",
        7: "Other (please specify)",
      }
      this.OlaStudyCycle = {
        "Short cycle or equivalent (EQF 5)": "Short cycle (EQF 5)",
        "Bachelor or equivalent first cycle (EQF 6)": "Bachelor (EQF 6)",
        "Master or equivalent second cycle (EQF 7)": "Master (EQF 7)",
        "Doctorate or equivalent (EQF 8)": "Doctorate (EQF 8)"
      }
      // this.academicYears = this.generateTenAcademicYears();
      this.academicYears = ["2021/2022", "2022/2023", "2023/2024", "2024/2025", "2025/2026", "2026/2027", "2027/2028", "2028/2029"];
      this.cefrLevel = [{code: 'A1'}, {code: 'A2'}, {code: 'B1'}, {code: 'B2'}, {code: 'C1'}, {code: 'C2'}];
      this.encryptionKey = (process.env.encryption_key || 'dq7jfp07wPagYWc8XV51ZoFgSHZGoLbA');
      this.mostSpokenLanguages = [{Code:'BG', Name:'Bulgarian'}, {Code:'CS' , Name:'Czech'}, {Code:'DA', Name:'Danish'}, {Code:'DE', Name:'German'}, {Code:'EL', Name:'Greek'}, {Code:'EN', Name:'English'}, {Code:'ES', Name:'Spanish'}, {Code:'ET', Name:'Estonian'}, {Code:'FI', Name:'Finnish'}, {Code:'FR', Name:'French'}, {Code:'GA', Name:'Irish'}, {Code:'HU', Name:'Hungarian'}, {Code:'IT', Name:'Italian'}, {Code:'LT', Name:'Lithuanian'}, {Code:'LV', Name:'Latvian'}, {Code:'MT', Name:'Maltese'}, {Code:'NL', Name:'Dutch'}, {Code:'PL', Name:'Polish'}, {Code:'PT', Name:'Portuguese'}, {Code:'RO', Name:'Romanian'}, {Code:'SK', Name:'Slovak'}, {Code:'SL', Name:'Slovenian'}, {Code:'SV', Name:'Swedish'}];
    }

    generateTenAcademicYears() {
      let currentYear = new Date().getFullYear();
			let academicYears = [];
			for (let i=0; i<50; i++) {
				let beginYear = currentYear + i;
				let endYear = currentYear + i + 1;
				academicYears.push(beginYear + "/" + endYear);
      }

      return academicYears;
    }

	getParameterByName(name) {
	    var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
	    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
	}

	generateLinkUrl(intl, base, detail){
        base = intl.get(base);
        detail = intl.get(detail);
        base = base.replace(/\s/g, "-");
        detail = detail.replace(/\s/g, "-");
        let url = "/"+base+"/"+detail;
        url = url.toLowerCase(url);
        return url;
    }

    generateExtraPageTitleTekst(){
    	console.log("GlobalVar");
    }

    checkIfObjectIsInLocalStorageArray(arrayName, objectToFind){
        if(localStorage.getItem(arrayName) !== null){
            const arrayToSearch = JSON.parse(localStorage.getItem(arrayName));
            if(arrayToSearch.indexOf(objectToFind) !== -1){
                return true;
            }
        }
        return false;
    }

    addToLocalStorageArray(arrayName, objectToAdd){
        let newArray = [objectToAdd];
        if(localStorage.getItem(arrayName) !== null){
            newArray = JSON.parse(localStorage.getItem(arrayName));
            newArray.push(objectToAdd);
        }
        localStorage.setItem(arrayName, JSON.stringify(newArray));
        //console.log(localStorage.getItem(arrayName));
    }

    removeLocalStorageFromArray(arrayName, objectToRemove){
        let newArray = JSON.parse(localStorage.getItem(arrayName));
        newArray.splice(newArray.indexOf(objectToRemove), 1);
        localStorage.setItem(arrayName, JSON.stringify(newArray));
        //console.log(localStorage.getItem(arrayName));
    }

    checkAccountFunction(functionName){
      if(!this.accountfunctions){
        return true;
      }
      let returnValue = false;
      this.accountfunctions.AccountFunction.AccountAbility.forEach((thisfunction) => {
          if(functionName.split(",").includes(thisfunction.Value)){
            returnValue = true;
          }
      })
      return returnValue;
    }
    fillNumber(num, len) {return (Array(len).join("0") + num).slice(-len);}

    getEWPNodeLink(){
      const thisHostName = window.location.hostname;
      if(thisHostName === "unizonedev.herokuapp.com"){
          return 'https://unizone-ewp.herokuapp.com';
      }
      else if(thisHostName === "unizonetest.herokuapp.com"){
          return 'https://unizone-ewp.herokuapp.com';
      }
      else if(thisHostName === "uporto-dev.herokuapp.com"){
        return 'https://unizone-ewp.herokuapp.com';
      }
      else if(thisHostName === "unizone-ola.herokuapp.com"){
        return 'https://unizone-ewp.herokuapp.com';
      }
      else if(thisHostName === "unizone-hei.herokuapp.com"){
        return 'https://unizone-ewp.herokuapp.com';
      }
      else if(thisHostName === "webdev22.it.auth.gr"){
        return 'https://unizone-ewp.herokuapp.com';
      }
      else if(thisHostName === "localhost"){
        return 'https://unizone-ewp.herokuapp.com';
      }
      else if(thisHostName === "unizone-stg01.it.auth.gr"){
        return 'https://unizone-ewp.herokuapp.com';
      }
      return 'https://unizoneewp.herokuapp.com';
  }

    getServerLink(){
        const thisHostName = window.location.hostname;
        if(thisHostName === "localhost"){
            return "http://localhost:4000";
        }
        else if(thisHostName === "unizonedev.herokuapp.com"){
            return 'https://unizoneserverdev.herokuapp.com';
        }
        else if(thisHostName === "unizonetest.herokuapp.com"){
            return 'https://unizoneservertest.herokuapp.com';
        }
        else if(thisHostName === "uporto-dev.herokuapp.com"){
          return 'https://uportoserver-dev.herokuapp.com';
        }
        else if(thisHostName === "webdev22.it.auth.gr"){
          return 'http://webdev22.it.auth.gr:4000';
        }
        else if(thisHostName === "unizone-stg01.it.auth.gr"){
          return 'https://unizonebnd-stg01.it.auth.gr';
        }
        else if(thisHostName === "unizone.it.auth.gr"){
          return 'https://unizonebnd.it.auth.gr';
        }
	else if(thisHostName === "unizone-ola.herokuapp.com"){
          return 'https://unizoneserver-ola.herokuapp.com';
        }
	else if(thisHostName === "unizone-hei.herokuapp.com"){
          return 'https://unizoneserver-hei.herokuapp.com';
        }
        return 'https://unizonebnd.it.auth.gr';
    }

    getClientLink(){

      if(window.location.hostname === "localhost"){
          return "http://localhost";
      }

      return "https://" + window.location.hostname;
  }

    setToken(){
      const ErasmusCode = localStorage.getItem("ErasmusCode");
      const Email = localStorage.getItem("Email");
      let token = {
        ErasmusCode,
        Email
      }
      token = JSON.stringify(token);
      token = this.encryptWithKey(token);
      localStorage.setItem("token", token);
    }
    setDefaultLocalStorage(){
      localStorage.setItem("columnValuesOutgoing", '["firstname","lastname","receivingInstitution","startMobility","endMobility"]');
      localStorage.setItem("columnValuesIncoming", '["firstname","lastname","sendingInstitution","startMobility","endMobility"]');
      localStorage.setItem("columnValuesIIAList", '["institutionName", "institutionErasmusCode", "", "signingName", "signingDate", "email", "phone", "website", "allowFactsheet", "mobilityType", "creatorErasmusCode", "partnerErasmusCode", "partnerContact", "academicYearId", "mobilitiesPerYear", "language", "cefrLevel", "iscedFCode", "eqfLevel"]');
      localStorage.setItem("filtersIncoming", '{"signedBefore":"-1","signedDuring":"-1"}');
      localStorage.setItem("filtersOutgoing", '{"signedBefore":"-1","signedDuring":"-1"}');
      // localStorage.setItem("filtersIIAList", '{}');
  		localStorage.setItem("sortByIncoming", "la_student.name");
      localStorage.setItem("sortByOutgoing", "la_student.name");
      localStorage.setItem("sortByIIAList", "IIAData.signingDate");
  		localStorage.setItem("sortDirectionIncoming", "asc");
      localStorage.setItem("sortDirectionOutgoing", "asc");
      localStorage.setItem("sortDirectionIIAList", "asc");
      this.setToken();
    }
    verifyToken(history){
      if(this.decryptWithKey(localStorage.getItem("ErasmusCode")) !== "EUFadmin"){
        if(localStorage.length === 0){
          return;
        }
        let token = localStorage.getItem("token");
        if(!token){
          this.logout(history);
          return;
        }
        try {
          token = this.decryptWithKey(token);
          token = JSON.parse(token);
          const ErasmusCode = localStorage.getItem("ErasmusCode");
          const Email = localStorage.getItem("Email");
          if(ErasmusCode !== token.ErasmusCode || Email !== token.Email){
            this.logout(history);
            return;
          }
        } catch (e) {
          this.logout(history);
          return;
        };
      }
    }
    logout(history){
  		localStorage.clear();
  		window.location.replace("/intro");
  	}
    decryptWithKey(value){
      const decryptingValue = AES.decrypt(decodeURIComponent(value).toString(), this.encryptionKey);
      return decryptingValue.toString(enc.Utf8)
    }
    encryptWithKey(value){
      return AES.encrypt(value, this.encryptionKey);
    }
}

export default (new GlobalVar);
